export default "__VITE_ASSET__CG$wU8I4__"